export default {
    path: 'project_base',
    name: 'project_base',
    component: r => require.ensure([], () => r(require('./index.vue')), 'project_base'),
    redirect: { name: 'project_base_list' },
    children: [
        {
            path: 'project_base_list',
            name: 'project_base_list',
            component: r => require.ensure([], () => r(require('./list.vue')), 'project_base_list'),
        },
        {
            path: 'project_detail',
            name: 'project_detail',
            component: r => require.ensure([], () => r(require('./detail/index.vue')), 'project_detail'),
            redirect: { name: 'project_dashboard' },
            children: [
                {
                    path: 'project_dashboard/:project_id',
                    name: 'project_dashboard',
                    component: r => require.ensure([], () => r(require('./detail/project_dashboard.vue')), 'project_dashboard'),
                },
                {
                    path: 'project_employee/:project_id',
                    name: 'project_employee',
                    component: r => require.ensure([], () => r(require('./detail/project_employee.vue')), 'project_employee'),
                },
                {
                    path: 'project_trouble/:project_id',
                    name: 'project_trouble',
                    component: r => require.ensure([], () => r(require('./detail/trouble/index.vue')), 'project_trouble'),
                },
                {
                    path: 'rhzp/:project_id',
                    name: 'rhzp',
                    component: r => require.ensure([], () => r(require('./detail/rhzp/index.vue')), 'rhzp'),
                },
                {
                    path: 'project_down/:project_id',
                    name: 'project_down',
                    component: r => require.ensure([], () => r(require('./detail/project_down.vue')), 'project_down'),
                },
                {
                    path: 'project_setting/:project_id',
                    name: 'project_setting',
                    component: r => require.ensure([], () => r(require('./detail/project_setting.vue')), 'project_setting'),
                },
                {
                    path: 'site_record/:project_id',
                    name: 'site_record',
                    component: r => require.ensure([], () => r(require('./detail/site_record.vue')), 'site_record'),
                },
                {
                    path: 'site_log/:project_id/:site_id',
                    name: 'site_log',
                    component: r => require.ensure([], () => r(require('./detail/site_log.vue')), 'site_log'),
                },
                {
                    path: 'site_report/:project_id',
                    name: 'site_report',
                    component: r => require.ensure([], () => r(require('./detail/site_report.vue')), 'site_report'),
                },
                {
                    path: 'site_czw_list/:project_id',
                    name: 'site_czw_list',
                    component: r => require.ensure([], () => r(require('./detail/site_czw_list.vue')), 'site_czw_list'),
                },
                {
                    path: 'site_sx_list/:project_id',
                    name: 'site_sx_list',
                    component: r => require.ensure([], () => r(require('./detail/site_sx_list.vue')), 'site_sx_list'),
                },
                {
                    path: 'site_other_list/:project_id',
                    name: 'site_other_list',
                    component: r => require.ensure([], () => r(require('./detail/site_other_list.vue')), 'site_other_list'),
                },
                {
                    path: 'record_zg_index/:project_id/:site_id/:site_type/:zg_type?',
                    name: 'record_zg_index',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/index.vue')), 'record_zg_index'),
                    props: route=>({
                        ...route.params,
                        zg_type:route.params.zg_type || 'index'
                    })
                },
                {
                    path: 'record_zg_gcgk/:project_id/:site_id/:site_type/:zg_type',
                    name: 'record_zg_gcgk',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/gcgk.vue')), 'record_zg_gcgk'),
                },
                {
                    path: 'record_zg_hz/:project_id/:site_id/:site_type/:zg_type',
                    name: 'record_zg_hz',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/jghz.vue')), 'record_zg_hz'),
                },
                { // 09页面特殊处理
                    path: 'record_zg_09/:project_id/:site_id/:site_type/:zg_type',
                    name: 'record_zg_09',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/09.vue')), 'record_zg_09'),
                },
                {
                    path: 'record_zg_zg/:project_id/:site_id/:site_type/:zg_type',
                    name: 'record_zg_zg',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/zg.vue')), 'record_zg_zg'),
                },
                {
                    path: 'fj_record/:project_id/:site_id/',
                    name: 'fj_record',
                    component: r => require.ensure([], () => r(require('./fj/fj_record.vue')), 'fj_record'),
                },
                {
                    path: 'record_zg_tp/:project_id/:site_id/:site_type',
                    name: 'record_zg_tp',
                    component: r => require.ensure([], () => r(require('./detail/record/zg/tp.vue')), 'record_zg_tp'),
                },
                {
                    path: 'record_cma_index/:project_id/:site_id/:site_type',
                    name: 'record_cma_index',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/index.vue')), 'record_cma_index'),
                },
                {
                    path: 'record_cma_gcgk/:project_id/:site_id/:site_type',
                    name: 'record_cma_gcgk',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/gcgk.vue')), 'record_cma_gcgk'),
                },
                {
                    path: 'record_cma_jczs/:project_id/:site_id/:site_type',
                    name: 'record_cma_jczs',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/jczs.vue')), 'record_cma_jczs'),
                },
                {
                    path: 'record_cma_hw311/:project_id/:site_id/:site_type',
                    name: 'record_cma_hw311',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/hw311.vue')), 'record_cma_hw311'),
                },
                {
                    path: 'record_cma_hw321/:project_id/:site_id/:site_type',
                    name: 'record_cma_hw321',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/hw321.vue')), 'record_cma_hw321'),
                },
                {
                    path: 'record_cma_jddz/:project_id/:site_id/:site_type',
                    name: 'record_cma_jddz',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/jddz.vue')), 'record_cma_jddz'),
                },
                {
                    path: 'record_cma_sydl/:project_id/:site_id/:site_type',
                    name: 'record_cma_sydl',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/sydl.vue')), 'record_cma_sydl'),
                },
                {
                    path: 'record_cma_jydz/:project_id/:site_id/:site_type',
                    name: 'record_cma_jydz',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/jydz.vue')), 'record_cma_jydz'),
                },
                {
                    path: 'record_cma_jl/:project_id/:site_id/:site_type',
                    name: 'record_cma_jl',
                    component: r => require.ensure([], () => r(require('./detail/record/cma/jl.vue')), 'record_cma_jl'),
                },
                {
                    path: 'report_zg_fj1/:project_id/:site_id/:site_type',
                    name: 'report_zg_fj1',
                    component: r => require.ensure([], () => r(require('./detail/report/zg/fj1.vue')), 'report_zg_fj1'),
                },
                {
                    path: 'report_zg_fj2/:project_id/:site_id/:site_type',
                    name: 'report_zg_fj2',
                    component: r => require.ensure([], () => r(require('./detail/report/zg/fj2.vue')), 'report_zg_fj2'),
                },
                {
                    path: 'report_zg_fj3/:project_id/:site_id/:site_type',
                    name: 'report_zg_fj3',
                    component: r => require.ensure([], () => r(require('./detail/report/zg/fj3.vue')), 'report_zg_fj3'),
                },
                {
                    path: 'report_zg_yj/:project_id/:site_id/:site_type',
                    name: 'report_zg_yj',
                    component: r => require.ensure([], () => r(require('./detail/report/zg/yj.vue')), 'report_zg_yj'),
                },
                {
                    path: 'report_cma_index/:project_id/:site_id/:site_type',
                    name: 'report_cma_index',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/index.vue')), 'report_cma_index'),
                },
                {
                    path: 'report_cma_gcgk/:project_id/:site_id/:site_type',
                    name: 'report_cma_gcgk',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/gcgk.vue')), 'report_cma_gcgk'),
                },
                {
                    path: 'report_cma_jczs/:project_id/:site_id/:site_type',
                    name: 'report_cma_jczs',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/jczs.vue')), 'report_cma_jczs'),
                },
                {
                    path: 'report_cma_hw311/:project_id/:site_id/:site_type',
                    name: 'report_cma_hw311',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/hw311.vue')), 'report_cma_hw311'),
                },
                {
                    path: 'report_cma_hw321/:project_id/:site_id/:site_type',
                    name: 'report_cma_hw321',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/hw321.vue')), 'report_cma_hw321'),
                },
                {
                    path: 'report_cma_jddz/:project_id/:site_id/:site_type',
                    name: 'report_cma_jddz',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/jddz.vue')), 'report_cma_jddz'),
                },
                {
                    path: 'report_cma_sydl/:project_id/:site_id/:site_type',
                    name: 'report_cma_sydl',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/sydl.vue')), 'report_cma_sydl'),
                },
                {
                    path: 'report_cma_jydz/:project_id/:site_id/:site_type',
                    name: 'report_cma_jydz',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/jydz.vue')), 'report_cma_jydz'),
                },
                {
                    path: 'report_cma_jl/:project_id/:site_id/:site_type',
                    name: 'report_cma_jl',
                    component: r => require.ensure([], () => r(require('./detail/report/cma/jl.vue')), 'report_cma_jl'),
                },
                {
                    path: 'site_doc/:project_id/:site_id/:site_type/:project_name',
                    name: 'site_doc',
                    component: r => require.ensure([], () => r(require('./detail/doc/index.vue')), 'site_doc'),
                },

            ]
        }
    ]
}
